import React from "react";
import GuideLayout from "../../components/layout/GuideLayout";
import Section from "../../components/layout/Section";
import Subheader from "../../components/layout/Subheader";
import {
  Typography
} from "@mui/material";
import BulletList from "../../components/layout/BulletList";

const schedule = [
  "New releases in the NC Mall typically drop at 10am NST.",
  "Dyeworks have been known to drop at 11am NST.",
  "Wednesday sales drop at midnight.",
  "Styling studio rotates around mid-month. TNT will post sneak peeks on their social media accounts sometimes.",
  "There are no mall drops on weekends.",
  "The new collectible and monthly GBC will drop 10am on the 1st of each month. If the 1st falls on a weekend, it will likely be the following Monday.",
];

const etiquette = [
  "Use a readable font (no bright colors, crazy font faces, etc)",
  "If you have your tl/wl in your neosignature and want to be nice to mobile users, consider having your link in just one line with no extra characters/symbols. That makes it easier for folks to copy and paste!",
  "If you are going away from the board, drop a note! This is especially helpful if there's an active trade/offer and waiting for a response.",
  "When you trade, copy the message about Your gift has been sent to (username) and post it on the board as a receipt. It's just something nice to do to signify that you have sent your end in good faith!",
];

const sections = [
  { id: "top", title: "Top" },
  { id: "schedules", title: "Schedules" },
  { id: "monthly-collectible", title: "Monthly Collectible" },
  {
    id: "neoboards", title: "Neoboards",
    children: [
      { id: "board-etiquette", title: "Board Etiquette" }]
  }
];

const MiscNCKnowledge = () => {
  return (
    <GuideLayout sections={sections}>
      <Section id="top" title="Miscellaneous NC Knowledge">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: June 2026
        </Typography>
        <Typography paragraph>
          Just things that may be helpful or fun to know as you're getting into NC trading!
        </Typography>
      </Section>

      <Section id="schedules" title="Schedules">
        Remember, none of this is guaranteed as TNT can delay/change releases at any time, though here's what many of us generally expect:
        <BulletList items={schedule} />
      </Section>

      <Section id="monthly-collectible" title="Monthly Collectible">
        <Typography paragraph>
          Every month, there will be a new collectible for direct purchase (250nc) in the mall. Each collectible belongs to a series (theme), and each series has 5 items. If you purchase each monthly collectible in a series, you will receive a bonus item when you buy the last item in the series. This means purchasing the entire series and getting the bonus will cost 250x5=1250nc total over the course of 5 months.
        </Typography>

        <Typography paragraph>
          It's important to note that you must <b>purchase</b> all the monthly collectibles to qualify for the bonus item. You will not receive the bonus item if you traded for the collectibles. If you miss a month and forget to purchase, you will not qualify for the bonus, so mark your calendars! It also does not matter where you have the collectibles after purchasing (use them on pets, trade away, leave in sdb, etc). As long as you purchased each collectible in the series, you will receive the bonus.
        </Typography>

        <Typography paragraph>
          You can only receive 1 bonus item per account. Even if you purchased 2 of each month's collectible in the series, you will still only receive 1 bonus item in the end. For that reason, some people purchase on their side accounts so they can own multiple bonuses in the end.
        </Typography>
      </Section>

      <Section id="neoboards" title="Neoboards">
        <Typography paragraph>
          The neoboards are a great way to find trades and ask questions, but did you know TNT makes boards sometimes too? There's no schedule for this and it's not often, but occasionally a TNT member might make a board to ask for upcoming Dyeworks item suggestions or seek general feedback. In the past, TNT Luna has also hosted customization contests! If you're interested in that kind of stuff, visit the boards every once in a while and maybe you'll catch something cool!
        </Typography>

        <Subheader id="board-etiquette" title="Board Etiquette" />
        If you're on the neoboards looking for trades, here's some things that are helpful to do:
        <BulletList items={etiquette} />

      </Section>

    </GuideLayout>
  );
};

export default MiscNCKnowledge;